module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_preview-365642b2.png";